var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverDumpTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "af94612e-a64e-4001-953d-4d82d90d2722",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a146a990-1c12-4f60-a441-f07b64e1d259,.b083b379-bca0-4849-84ca-f925c7add1b5{fill:none;}.b083b379-bca0-4849-84ca-f925c7add1b5{clip-rule:evenodd;}.ab55975a-3847-46ce-b4b5-3742d81d7dd3{clip-path:url(#a973641f-7192-4494-b735-416436d29087);}.aa512739-62a5-4fda-a5bb-a99b1bc17ae7{fill:#d8d8d8;}.eca4b04c-5d9a-49ea-b527-4ede1a73b5d7{clip-path:url(#ebcbd15a-6c16-4841-8a01-f34587fd74c7);}.a2e48fb0-687e-48e7-9724-c13d27ef0158{clip-path:url(#f869b766-59c5-4c45-b415-1ad77d5ce656);}.bbbc4d2f-2294-4407-82c4-28f0b0d58f38{clip-path:url(#f5606709-6ae8-468e-b8a8-763b448fd395);}.bbec7d47-2acf-4599-a8da-07d775e65a6d{clip-path:url(#e1e4eebd-eef8-46bb-91b8-a5d7e2971076);}.e788bb1f-b984-4d1d-82f4-efdd8278e5b5{clip-path:url(#aa98a9cb-029f-4237-b749-1ac7de1fa85c);}.a1ecb70f-9d10-43d2-ab16-00a0479c30b1{clip-path:url(#aa7e2a90-6b5d-4073-8a4c-08726b022172);}.e4ebec4d-019b-4d65-8e44-9e519bc33ac0{clip-path:url(#ea144c9f-0939-410f-ac15-aa6999af6156);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a973641f-7192-4494-b735-416436d29087"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a146a990-1c12-4f60-a441-f07b64e1d259",
    d: "M19.31-6a.88.88,0,0,0,.88-.89.88.88,0,0,0-.88-.89.89.89,0,0,0-.89.89A.89.89,0,0,0,19.31-6Zm0-3.43a2.52,2.52,0,0,1,2.51,2.54,2.53,2.53,0,0,1-2.51,2.54,2.53,2.53,0,0,1-2.52-2.54A2.53,2.53,0,0,1,19.31-9.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ebcbd15a-6c16-4841-8a01-f34587fd74c7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a146a990-1c12-4f60-a441-f07b64e1d259",
    d: "M11.63-6a.88.88,0,0,0,.88-.89.88.88,0,0,0-.88-.89.89.89,0,0,0-.89.89A.89.89,0,0,0,11.63-6Zm0-3.43a2.52,2.52,0,0,1,2.51,2.54,2.53,2.53,0,0,1-2.51,2.54A2.53,2.53,0,0,1,9.11-6.93,2.53,2.53,0,0,1,11.63-9.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f869b766-59c5-4c45-b415-1ad77d5ce656"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a146a990-1c12-4f60-a441-f07b64e1d259",
    d: "M6-6a.89.89,0,0,0,.88-.89A.88.88,0,0,0,6-7.8a.89.89,0,0,0-.89.89A.89.89,0,0,0,6-6ZM6-9.45A2.52,2.52,0,0,1,8.47-6.91,2.53,2.53,0,0,1,6-4.37,2.53,2.53,0,0,1,3.44-6.91,2.53,2.53,0,0,1,6-9.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5606709-6ae8-468e-b8a8-763b448fd395"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b083b379-bca0-4849-84ca-f925c7add1b5",
    points: "20.14 3.52 20.14 5.74 14.44 5.74 12.62 13.48 3.9 13.48 2.44 7.48 1.01 7.48 1.01 5.74 12.47 5.74 13.24 3.52 20.14 3.52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1e4eebd-eef8-46bb-91b8-a5d7e2971076"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a146a990-1c12-4f60-a441-f07b64e1d259",
    d: "M17.33,11.75a.28.28,0,0,0,.26.3h4.54a.28.28,0,0,0,.26-.29V11.5a.66.66,0,0,0-.05-.28L20.91,8.48a.62.62,0,0,0-.58-.39H17.81c-.41,0-.48,0-.48.5ZM2.11,15.34a1,1,0,0,1,1-.94h12.6a.59.59,0,0,0,.59-.6V7.32a.18.18,0,0,1,.18-.18h4.3a.94.94,0,0,1,.86.57l2.12,4v0a1,1,0,0,1,.08.38l-.05,7.55a1,1,0,0,1-.95.95h-.14a.18.18,0,0,1-.18-.18,3.18,3.18,0,1,0-6.35,0,.18.18,0,0,1-.18.18H15a.18.18,0,0,1-.18-.18,3.17,3.17,0,0,0-5.87-1.69.17.17,0,0,1-.3,0,3.17,3.17,0,0,0-5.84,1.74.22.22,0,0,0,0,.08,1,1,0,0,1-.71-1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa98a9cb-029f-4237-b749-1ac7de1fa85c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a146a990-1c12-4f60-a441-f07b64e1d259",
    d: "M19.31,21.34a.9.9,0,1,0-.89-.9A.89.89,0,0,0,19.31,21.34Zm0-3.44a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,19.31,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa7e2a90-6b5d-4073-8a4c-08726b022172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a146a990-1c12-4f60-a441-f07b64e1d259",
    d: "M11.63,21.34a.9.9,0,1,0-.89-.9A.89.89,0,0,0,11.63,21.34Zm0-3.44a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,11.63,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea144c9f-0939-410f-ac15-aa6999af6156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a146a990-1c12-4f60-a441-f07b64e1d259",
    d: "M6,21.35a.89.89,0,1,0-.89-.89A.88.88,0,0,0,6,21.35Zm0-3.43a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,6,17.92Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ab55975a-3847-46ce-b4b5-3742d81d7dd3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: 11.79,
    y: -14.47,
    width: 15.03,
    height: 15.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "eca4b04c-5d9a-49ea-b527-4ede1a73b5d7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: 4.11,
    y: -14.47,
    width: 15.03,
    height: 15.08
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a2e48fb0-687e-48e7-9724-c13d27ef0158"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: -1.56,
    y: -14.45,
    width: 15.03,
    height: 15.08
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "bbbc4d2f-2294-4407-82c4-28f0b0d58f38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: -3.99,
    y: -1.47,
    width: 29.13,
    height: 19.95
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "bbec7d47-2acf-4599-a8da-07d775e65a6d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: -2.92,
    y: 2.14,
    width: 31.72,
    height: 23.42
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "e788bb1f-b984-4d1d-82f4-efdd8278e5b5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: 11.79,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "a1ecb70f-9d10-43d2-ab16-00a0479c30b1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: 4.11,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "e4ebec4d-019b-4d65-8e44-9e519bc33ac0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aa512739-62a5-4fda-a5bb-a99b1bc17ae7",
    x: -1.56,
    y: 12.92,
    width: 15.03,
    height: 15.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverDumpTruck);
export default __webpack_public_path__ + "static/media/deliver-dump-truck.dc8aa8b8883033ce1dd12c5db83c0b20.svg";
export { ForwardRef as ReactComponent };